<template>
	<div>
		<v-card flat color="transparent">
			<v-card-text>
                <v-row justify="center">
					<v-col cols="12"  class="mx-0 px-0"> 
                        <v-card  color="" class="px-9 py-10">
                            <v-row justify="center">
                                <v-col cols="12" md="10">
                                    <v-card-text>
                                        <v-row justify="center" >
                                            <v-col class="text-center col-md-5">
                                                <div class="font-weight-bold body-1">
                                                    Cursos Grupo Merca
                                                </div>
                                            </v-col>
                                        </v-row>
                                        <v-row align="center">
                                            <v-col cols="12" md="5" lg="4" class="my-0 py-0">
                                                <AlternativeAutocompleteOne
                                                    :label="'Empresa'"
                                                    :items="serverItems.companies"
                                                    :valueInput="selectedCompany"
                                                    :loading="loadingCompanies"
                                                    @valueChange="(v) => {selectedCompany = v; index()}"
                                                ></AlternativeAutocompleteOne>
                                            </v-col>
                                            <!-- <v-col cols="12" md="5" lg="2" class="my-0 py-0">
                                                <AlternativeAutocompleteOne
                                                    :label="'Estatus'"
                                                    :items="serverItems.statuses"
                                                    :valueInput="selectedStatus"
                                                    @valueChange="(v) => {selectedStatus = v; index()}"
                                                ></AlternativeAutocompleteOne>
                                            </v-col> -->
                                            
                                            
                                            <v-spacer></v-spacer>
                                           
                                        </v-row>

                                        <v-row v-if="loadingData">
                                           <v-col align-self="center" class="text-center">
                                                <v-progress-circular
                                                    size="70"
                                                    indeterminate
                                                    color="secondary"
                                                ></v-progress-circular>
                                            </v-col>
                                        </v-row>

                                        <v-row v-if="courses.length == 0 && !loadingData">
                                           <v-col align-self="center" class="text-center">
                                                <p class="pt-5">No Hay cursos para la empresa seleccionada</p>
                                            </v-col>
                                        </v-row>

                                        <v-row justify="start" class="pt-2" v-if="!loadingData">
                                            <v-col class="text-center" cols="12" md="6" v-for="(course, index) in courses" :key="index">
                                                <div @click="openCourse(course.id)">
                                                    <CourseItem class=" clic"  :course="course" :showChipStatus="true">
                                                    </CourseItem>
                                                </div>
                                                
                                            </v-col>
                                             
                                        </v-row>
                                    </v-card-text>
                                </v-col>
                            </v-row>
                            
                        </v-card>

					</v-col>
				</v-row>
				
				
			</v-card-text>
		</v-card>

        
	</div>
</template>
<script>
import PageStateManager from '../../../../helpers/PageStateManager';

import CourseItem from './CourseItem.vue';
export default {
    components: {
        CourseItem
    },
    data(){
		return {
            selectedCompany: PageStateManager.getState(this.$router.history.current.path, 'selectedCompany')??'ALL',
            selectedStatus: PageStateManager.getState(this.$router.history.current.path, 'selectedStatus')??'0',
            loadingCompanies: false,
			selectedID: '',
            loadingData:true,
            courses:[],
			
			
		

			modalProps: {
				visible: false,
				width: '500',
				title: 'Eliminar',
				text: '¿Estás seguro de eliminar?',
				loading: false,
				bottomLineColor: 'error',
				
			},
			
			cancelModal: {
                text: "No, regresar",
                icon: "",
				to: "",
				block: true,
				color: '',
                click: ()=>{this.modalProps.visible = false}
            },
			acceptModal: {
                text: "SI, ELIMINAR",
                icon: "",
				to: "",
				block: true,
				color: 'error',
				textColor:'white',
				loading:false,
                click: ()=>{this.delete()}
            },



            modalReturnAssetProps: {
				visible: false,
				width: '500',
				title: 'Remover responsable',
				text: '¿Estás seguro de remover al responsable del activo?',
				loading: false,
				bottomLineColor: 'error',
				
			},
			
			cancelReturnAssetModal: {
                text: "No, regresar",
                icon: "",
				to: "",
				block: true,
				color: '',
                click: ()=>{this.modalReturnAssetProps.visible = false}
            },
			acceptReturnAssetModal: {
                text: "SI, remover",
                icon: "",
				to: "",
				block: true,
				color: 'error',
				textColor:'white',
				loading:false,
                click: ()=>{this.returnAsset()}
            },

            serverItems:{
                companies:[],
				statuses:[
					{text: "Disponibles", value: "0"},
					{text: "Borradores", value: "1"},
				]
            }
		}
	},

    watch: {
       
        [`selectedCompany`]: function () {
            console.log(this.selectedCompany)
            PageStateManager.setState(this.$router.history.current.path, 'selectedCompany', this.selectedCompany)
        },
        [`selectedStatus`]: function () {
            console.log(this.selectedStatus)
            PageStateManager.setState(this.$router.history.current.path, 'selectedStatus', this.selectedStatus)
        },
		
    },

	mounted(){
		// this.index()
        this.getBusiness();
	},

    methods: {
        method_handler(object){
			this[object.method_name](object.parameters)
		},

        getBusiness()
        {
            this.serverItems.companies = [];
            this.loadingCompanies = true;
            this.$api.user.getUserBusinessSelect()
				.then((resp) =>{
                    
                    //index filter
					// this.serverItems.companies = resp.data.map((comp) => {
					// 	return {value: comp.id, text: `${comp.name}`}
					// });
                    this.serverItems.companies.push({value: "ALL", text: "Todas"});
                    resp.data.forEach(comp => {
                        this.serverItems.companies.push({value: comp.id, text: `${comp.name}`});
                    });

                    

					if(this.serverItems.companies.length >= 1){
						if(this.selectedCompany == "")
                            this.selectedCompany = this.serverItems.companies[0].value;
						this.index();
                        
					}

                    
					
				})
				.catch((error) =>{
					console.log(error, "error getBusinessSelect");
				})
				.finally(() => {
                    this.loadingCompanies = false;
				})
			;
        },

        openCourse(id){
            console.log(id)
            this.$router.push({ name: 'ReadCourseDetail', params: { id: id }}).catch(()=>{});
            
        },
		index() {

            if(this.selectedCompany == null || this.selectedCompany == "")
                return;
            this.loadingData = true;

            const filter = this.generateFilter();

			//call api
			this.$api.course.index(filter)
				.then((resp) =>{
					console.log(resp)
                    this.courses = resp.data.data.map((x) => {
                        // x['status'] = 'in_progress';
                        return x;
                    });

                    // this.courses[0].image = "https://picsum.photos/510/300?random";
				})
				.catch((error) =>{
					console.log(error, "error desde areas");
				})
				.finally(() => {
					this.loadingData = false;
				})
			;
			//console.log(test);
			
			
			
		},

        generateFilter()
        {
            let filter = `?page=1&itemsPerPage=999&filter[draft]=${this.selectedStatus}`;

            if(this.selectedCompany != 'ALL'){
                filter = `${filter}&filter[companies]=${this.selectedCompany}`
            }

            return filter;
        }


        



    }
}
</script>

<style lang="scss">
    .courses{
        &-item-container{
            border: 1px solid rgb(187, 185, 185);
            border-radius: 0.8rem;
            display: flex;
            align-items: flex-start;
            padding: 10px 5px;
        }

        &-img{
            flex: 0 0 30%; /* Enforces exactly 50% width */
        }


        &-item-texts{
            flex: 0 0 70%; /* Enforces exactly 50% width */
            justify-items: flex-start;
            font-size: 0.86rem;
            color: #605f5f; //var(--v-normalText-base) !important;
            p{
                padding: 3px 0;
                margin-bottom: 0;
            }

            &-title{
                 color:var(--v-normalText-base) !important;
                font-weight: 700;
                font-size: 1rem;
            }
        }
    }
</style>